let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f1x0y")).then(() => parcelRequire('c8wfa'));